import { InspectionModel } from 'api/models';
import {
  getApiActionTypes,
  getApiActionTypesValues,
} from 'store/redux/redux_utils';
import { AppAction, AppState } from '../types';

/**
 * Action constants
 */
const constants = {
  ...getApiActionTypes('FETCH_INSPECTIONS'),
};

/**
 * Actions
 */
// `dispatch` and the middleware's `client` are `any` for the reason spelled out
// in `use-app-dispatch.ts`: `clientMiddleware` is untyped JS and returns
// whatever the API client resolved to, not the action.
const fetchInspections = (involvedRole: string) => (dispatch: any) => {
  return dispatch({
    types: getApiActionTypesValues('FETCH_INSPECTIONS'),
    promise: async ({ client }: { client: any }) =>
      client.get(`/inspections?involvedRole=${involvedRole}`),
    auth: true,
  });
};

export const fetchHomeownerInspections = () => async (dispatch: any) => {
  const data = await dispatch(fetchInspections('Homeowner'));
  return data;
};

/**
 * Reducer
 */
export const INSPECTION_REDUCER = 'inspection';

const initialState = {
  inspections: [],
};

export default function reducer(state = initialState, action: AppAction = {}) {
  switch (action.type) {
    case constants.FETCH_INSPECTIONS_SUCCESS:
      return {
        ...state,
        inspections: action.result,
      };
    default:
      return state;
  }
}

/**
 * Selectors
 */
export const selectInspections = (state: AppState): InspectionModel[] =>
  state[INSPECTION_REDUCER].inspections;
